var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabycarriage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 70,
    viewBox: "0 0 447.09 446.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #183f75;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.04,303.21l-5.71,11.2-3.64,7.14-3.65,7.15-15.16,29.72-3.58,7.02-3.63,7.11-6.21,12.17c-3.39-4.01-8.32-6.66-13.87-7.08l6.22-12.18,3.62-7.11,3.6-7.03,13.65-26.75,3.58-7.03,3.57-6.99,7.35-14.41c1.95-3.83,6.65-5.35,10.48-3.39,3.83,1.95,5.35,6.64,3.39,10.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.75,377.75c-5.49.69-10.29,3.59-13.48,7.79l-6.84-11.83-3.99-6.91-3.95-6.83-17.51-30.33-4.1-7.11-4.13-7.16-15.8-27.36c-2.15-3.73-.87-8.49,2.85-10.63,3.72-2.16,8.49-.88,10.63,2.85l18.25,31.61,4.02,6.98,4.01,6.94,15.25,26.41,3.95,6.84,3.99,6.91,6.84,11.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.87,358.41c-4.17-3.07-8.84-5.48-13.86-7.1-4.72-1.53-9.75-2.35-14.96-2.35-26.91,0-48.8,21.89-48.8,48.81s21.89,48.8,48.8,48.8,48.8-21.89,48.8-48.8c0-16.14-7.87-30.47-19.98-39.35ZM173.05,377.57c.51,0,1.02.02,1.53.06,5.55.41,10.48,3.07,13.87,7.08,2.99,3.52,4.8,8.08,4.8,13.06,0,11.15-9.05,20.19-20.2,20.19s-20.2-9.04-20.2-20.19,9.04-20.2,20.2-20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.32,348.96c-6.1,0-11.95,1.13-17.35,3.18-4.92,1.88-9.47,4.53-13.48,7.81-10.96,8.96-17.98,22.59-17.98,37.81,0,26.91,21.89,48.8,48.8,48.8s48.81-21.89,48.81-48.8-21.89-48.81-48.81-48.81ZM357.32,417.96c-11.15,0-20.19-9.04-20.19-20.19,0-4.6,1.54-8.84,4.13-12.24,3.19-4.2,8-7.1,13.48-7.79.84-.12,1.7-.17,2.57-.17,11.16,0,20.2,9.04,20.2,20.2s-9.04,20.19-20.2,20.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.97,113.55c-.03-.05-.06-.11-.1-.16v-.02c-1.4-2.15-3.81-3.58-6.56-3.58H7.79c-4.3,0-7.79,3.49-7.79,7.79s3.49,7.79,7.79,7.79h41.41s27.9,41.05,27.9,41.05h18.82l-35.94-52.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.53,181.99c-1.53,19.12-6.15,37.25-13.8,54.06-9.14,20.09-22.37,37.81-39.3,52.68-19.32,16.96-42.77,29.48-68.71,37.01-5.15,1.49-10.4,2.79-15.73,3.88-14.07,2.9-28.74,4.39-43.76,4.39-16.61,0-32.79-1.81-48.2-5.32-5.22-1.18-10.35-2.56-15.37-4.13-24.36-7.6-46.39-19.66-64.67-35.69-16.92-14.82-30.13-32.53-39.26-52.61-7.67-16.86-12.3-35.06-13.82-54.27h362.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.09,166.42h-189.78L317.98,9.95c1.53-3.95,4.66-7.15,8.58-8.77,3.9-1.61,8.35-1.56,12.21.14,65.4,28.95,107.82,93.67,108.33,165.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabycarriage);
export default __webpack_public_path__ + "static/media/Babycarriage.ec51f3a0ffb9abd80ab52542e9d3f78d.svg";
export { ForwardRef as ReactComponent };